import { Routes } from '@angular/router';
import { authGuard } from './auth.guard';
import { orgAdminGuard } from './org-admin.guard';
import { AddQuestionComponent } from './pages/questions/add-question/add-question.component';
import { UploadComponent } from './pages/upload/upload.component';
import { AuthenticationComponent } from './layout/authentication/authentication.component';
import { MainComponent } from './layout/main/main.component';
import { MeetingsComponent } from './pages/meetings/meetings.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { OpportunityDetailComponent } from './pages/dashboard/opportunity/opportunity-detail/opportunity-detail.component';
import { OptionsComponent } from './pages/settings/options/options.component';
import { OnboardingComponent } from './pages/onboarding/onboarding.component';
import { ChoosePlanComponent } from './pages/choose-plan/choose-plan.component';
import { OrgAdminComponent } from './pages/org-admin/org-admin.component';
import { OrgMembersComponent } from './pages/org-admin/org-members/org-members.component';

export const routes: Routes = [{
  path: '',
  component: MainComponent,
  children: [
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    {
      path: 'onboarding',
      component: OnboardingComponent,
      canActivate: [authGuard],
    },
    {
      path: 'choose-plan',
      component: ChoosePlanComponent,
      canActivate: [authGuard],
    },
    {
      path: 'dashboard',
      component: DashboardComponent,
      canActivate: [authGuard],
    },
    {
      path: 'opportunity-detail/:opportunityId/:botId',
      component: OpportunityDetailComponent,
      canActivate: [authGuard],
    },
    {
      path: 'add-question',
      component: AddQuestionComponent,
      canActivate: [authGuard],
    },
    {
      path: 'upload',
      component: UploadComponent,
      canActivate: [authGuard],
    },
    {
      path: 'meetings',
      component: MeetingsComponent,
      canActivate: [authGuard],
    },
    {
      path: 'settings',
      component: OptionsComponent,
      canActivate: [authGuard],
    },
    {
      path: 'organization',
      component: OrgAdminComponent,
      canActivate: [authGuard, orgAdminGuard],
      children: [
        { path: '', redirectTo: 'members', pathMatch: 'full' },
        { path: 'members', component: OrgMembersComponent },
      ],
    },
  ]
}, {
  path: '',
  component: AuthenticationComponent,
  children: [{
    path: '',
    loadChildren: () =>
      import('./pages/authorization/authorization.module').then(
        (m) => m.AuthorizationModule
      ),
  }, {
    path: 'accept-invite',
    loadComponent: () =>
      import('./pages/accept-invite/accept-invite.component').then(
        (m) => m.AcceptInviteComponent
      ),
  }]
}, {
  path: '**',
  redirectTo: 'modules/pages/miscellaneous/error'
}];
